import { useEffect } from "react"

import { Tile } from "@/App/LiveRates/Tile"
import { Loader } from "@/components/Loader"
import { useCurrencyPair } from "@/services/currencyPairs"
import { useLocalStorage } from "@/utils"
import { closeWindow } from "@/utils/closeWindow"
import { withSubscribe } from "@/utils/withSubscribe"

import { SELECTED_VIEW_KEY, TileView } from "../../tiles.state"
import { useTearOutEntry } from "./tearOut.state"

export const TornOutTile = withSubscribe<{
  symbol: string
  view: TileView
  supportsTearOut?: boolean
}>(
  ({ symbol, view: initView, supportsTearOut }) => {
    const [view] = useLocalStorage(SELECTED_VIEW_KEY, initView)
    const tearOutEntry = useTearOutEntry()

    useEffect(() => {
      if (tearOutEntry) {
        const [, tornOut] = tearOutEntry
        if (!tornOut) {
          closeWindow()
        }
      }
    }, [tearOutEntry])

    return (
      <div className="h-screen overflow-y-auto p-2">
        <Tile
          currencyPair={useCurrencyPair(symbol)}
          showingChart={view === TileView.Chart}
          isTornOut
          supportsTearOut={supportsTearOut}
        />
      </div>
    )
  },
  {
    fallback: <Loader ariaLabel="Loading live FX exchange rates" />,
  },
)
